import React, {useEffect, useRef, useState} from 'react';
import {Alert, Button, Card, Input, Space, Table, Tag, Typography, message} from 'antd';
import {mallAPI} from '../services/api';

export function OrderLookupInput({value,onChange,onSearch}) {
  return <Input.Search value={value} maxLength={128} allowClear style={{width:460,maxWidth:'100%'}}
    placeholder="订单号／支付单号／交易号／玩家账号／游戏UID"
    onChange={event=>onChange(event.target.value)}
    onSearch={text=>{const keyword=text.trim();if(!keyword){message.warning('请输入订单号、账号或游戏 UID；空查询不会清除已有结果');return;}onSearch(keyword);}}
    enterButton="全区查单"/>;
}
const statuses=['待支付','已支付','处理中','已完成','已取消'];
export const lookupColumns=[
  {title:'订单号',dataIndex:'order_no',width:260,render:text=><Typography.Text code copyable>{text}</Typography.Text>},
  {title:'来源',dataIndex:'order_sources',width:160,render:items=>(items||[]).map((s,i)=><Tag key={s.type+':'+i}>{s.label}</Tag>)},
  {title:'账号 / 区服 / 游戏UID',key:'account',width:230,render:(_,o)=><div>{o.target_account_name||o.user_id}<br/>{o.server_id}区 · UID {o.character_id||'-'}</div>},
  {title:'商品',dataIndex:'product_name',width:180},
  {title:'订单金额',dataIndex:'total_amount',width:120,render:v=>'¥'+Number(v||0).toFixed(2)},
  {title:'状态',dataIndex:'status',width:100,render:s=>statuses[s]||String(s)},
  {title:'统计口径',key:'policy',width:170,render:(_,o)=><div>计入累充：{Number(o.counts_cumulative)?'是':'否'}<br/>计入现金流水：{Number(o.counts_cash)?'是':'否'}</div>},
  {title:'创建时间',dataIndex:'create_time',width:180,render:t=>t?new Date(t).toLocaleString('zh-CN'):'-'}
];
export default function OrderLookupPanel({lookup=mallAPI.lookupOrders,agentScope=false,onActiveChange}) {
  const [draft,setDraft]=useState(''),[keyword,setKeyword]=useState('');
  const [data,setData]=useState(null),[loading,setLoading]=useState(false),[error,setError]=useState('');
  const seq=useRef(0);
  useEffect(()=>()=>{++seq.current;},[]);
  const run=async(text,page=1,limit=20)=>{
    const current=++seq.current;setKeyword(text);setDraft(text);setLoading(true);setError('');setData(null);onActiveChange?.(true);
    try{
      const response=await lookup({keyword:text,page,limit});
      if(current!==seq.current)return;
      if(!response.data?.success||!Array.isArray(response.data?.data?.orders)||!Number.isFinite(Number(response.data?.data?.pagination?.total)))throw Error('订单查询响应异常');
      setData(response.data.data);
    }catch(e){if(current===seq.current)setError(e.response?.data?.message||e.message||'查询失败');}
    finally{if(current===seq.current)setLoading(false);}
  };
  const reset=()=>{++seq.current;setDraft('');setKeyword('');setData(null);setError('');setLoading(false);onActiveChange?.(false);};
  return <Card title={agentScope?'全区订单查询（仅可见玩家）':'全区统一订单查询'} style={{marginBottom:16}}>
    <Space wrap><OrderLookupInput value={draft} onChange={setDraft} onSearch={text=>run(text)}/><Button onClick={reset}>清空查询</Button></Space>
    <div style={{margin:'10px 0',color:'#64748b'}}>同一入口查询商城、新旧客服代充及平台币补发；仅查询，不补单、不发币，不改变现金流水和返佣规则。{agentScope?'权限仍限本人及授权下级的玩家。':''}</div>
    {keyword&&<Alert style={{marginBottom:12}} type={error?'error':loading?'info':data?.pagination.total?'success':'warning'} showIcon
      message={`查询关键词：${keyword} · ${loading?'查询中…':error?'查询失败':`共 ${data?.pagination.total||0} 笔订单`}`} description={error||undefined}/>}
    {keyword&&<Table rowKey="id" columns={lookupColumns} dataSource={data?.orders||[]} loading={loading} scroll={{x:1480}}
      pagination={data?{current:data.pagination.page,pageSize:data.pagination.limit,total:data.pagination.total,showSizeChanger:true,onChange:(p,l)=>run(keyword,p,l)}:false}
      locale={{emptyText:error?'请求失败，请重新查询（不是零订单）':'未找到匹配订单，请核对关键词及账号权限'}}/>}
  </Card>;
}
